import { useTranslation } from 'react-i18next';

export const useDeviceType = () => {
    const { t } = useTranslation();
    return { TABLET: t('DEVICE_TYPE.TABLET'), PHONE: t('DEVICE_TYPE.PHONE') };
};

export type DeviceType = keyof ReturnType<typeof useDeviceType>;
